import { USEABLE_FLAG } from '@/business/couponList';
import { i18n } from '@/i18n';
import { Route } from 'vue-router';
import couponIconDisabled from '../assets/images/new-version/coupon-disabled.png';
import couponIconActive from '../assets/images/new-version/coupon-icon.png';
import discountIconDisabled from '../assets/images/new-version/discount-disabled.png';
import discountIconActive from '../assets/images/new-version/discount-icon.png';
import weCouponActive from '../assets/images/new-version/wecoupon-icon.png';
import weCouponDisabled from '../assets/images/new-version/wecoupon-disabled.png';
import { isFromWecoupons, isShowWeCouponsBottomTab } from '@/business/we-coupons';


export const HeaderTabType = {
  couponlist: 'couponlist',
  displaycouponlist: 'displaycouponlist',
} as const;

export const HeaderTabText = [
  { key: HeaderTabType.couponlist, text: i18n('自動扣減券') },
  { key: HeaderTabType.displaycouponlist, text: i18n('手動啟用券') },
];

export const BottomTabType = {
  home: 'home',
  homeNewest: 'homeNewest',
  couponlist: 'couponlist',
  weCoupons: 'weCoupons', //  抢券有SO
};

export const getBottomTabText = () =>  {
  const springBottomTabConfig = [
    { key: BottomTabType.home, text: i18n('優惠'), ...getBottomTabIcon(BottomTabType.home) },
    { key: BottomTabType.weCoupons, text: i18n('領券'), ...getBottomTabIcon(BottomTabType.weCoupons) },
    { key: BottomTabType.couponlist, text: i18n('我的禮遇'), ...getBottomTabIcon(BottomTabType.couponlist) },
  ];
  const res = springBottomTabConfig;

  return isFromWecoupons() ? res.filter(item => item.key !== BottomTabType.home) : res;
};

export const getBottomTabIcon = (tabType: string) => {
  switch (tabType) {
    case (BottomTabType.home):
      return  { iconSrc: discountIconActive, iconSrcDisabled: discountIconDisabled };
    case (BottomTabType.couponlist):
      return { iconSrc: couponIconActive, iconSrcDisabled: couponIconDisabled };
    case (BottomTabType.weCoupons): {
      const normalSrc = { iconSrc: weCouponActive, iconSrcDisabled: weCouponDisabled };
      return normalSrc;
    }
    default:
      return;
  }
};

/**
 * 判断顶部tab 路由是否为【卡券】类型，且qry type不为【已失效列表】
 * @param curRoute 当前路由
 * @returns boolean
 */
export const isHeaderTabPage = (curRoute: Route) => {
  if (curRoute?.name) {
    const curOriginRoute = curRoute.name;
    return Object.keys(HeaderTabType).includes(curOriginRoute) && curRoute.query.type !== USEABLE_FLAG.INVALID;
  }
  return false;
};
/**
 * 默认选中 Tab：优先自动扣减券，其次手动启用券，否则回落自动扣减券。
 * 供「首页入口」与「底部我的礼遇入口」复用，保证跳转口径一致。
 */
export const resolveDefaultHeaderTab = (couponCount?: number, displayCount?: number): string => {
  if (typeof couponCount === 'number' && couponCount > 0) {
    return HeaderTabType.couponlist;
  }
  if (typeof displayCount === 'number' && displayCount > 0) {
    return HeaderTabType.displaycouponlist;
  }
  return HeaderTabType.couponlist;
};

export const getActiveInfo = (curRoute: Route): { activeTab: string | undefined } => {
  if (!curRoute.name) return { activeTab: undefined };
  const routeName = curRoute.name;
  const tabInfo = HeaderTabText.find(item => item.key === routeName);
  return {
    activeTab: tabInfo?.key,
  };
};


/**
 * 判断底部tab
 * @param curRoute 当前路由
 * @returns boolean
 */
export const isBottomTabPage = (curRoute: Route) => {
  const curOriginRoute = curRoute.name;
  return isHeaderTabPage(curRoute)
    || (curOriginRoute === BottomTabType.home || curOriginRoute === BottomTabType.homeNewest)
    || isShowWeCouponsBottomTab(curRoute.path);
};
